import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Parser from "html-react-parser";

const NetworkQualityModal = ({ marker, onClose}) => {
    
    if (!marker) return null;
    
    return (
      <Modal open={!!marker} onClose={onClose}>
        <Box className="modal-box">
          <Typography variant="h4" gutterBottom>Στοιχεία Θέσης</Typography>
          <Typography variant="h6">{marker.metrics[0][1]}</Typography>
          {marker.metrics && marker.metrics[0].slice(2).map((metric, idx) => (
              <Box key={idx} sx={{ my: 1 }}>
                {Parser(metric)}
              </Box>
          ))}
            
          <Typography variant="subtitle1" gutterBottom>Μετρήσεις συστήματος:</Typography>
          
          {marker.metrics && marker.metrics[1].map((metric, idx) => (
              <Box key={idx} sx={{ my: 1 }}>
                {Parser(metric)}
              </Box>
          ))}
  
        </Box>
      </Modal>
    );
  };
  
  export default NetworkQualityModal;